import styled from 'styled-components';
import {
  GraphAreaContainer,
} from '../Grid';

export const marginalLegendSize = 30; // in px
export const axisLabelsSize = 40; // in px
export const yAxisTicksWidth = 40; // in px
export const topLabelSize = 30; // in px
export const xAxisTicksHeight = 10; // in px

const gridLines = {
  // columns:
  yLegendLeft: 'growth-dynamics-chart-y-legend-left',
  yLegendRight: 'growth-dynamics-chart-y-legend-right',
  yAxisLabelLeft: 'growth-dynamics-chart-y-label-left',
  yAxisLabelRight: 'growth-dynamics-chart-y-label-right',
  yTicksLeft: 'growth-dynamics-chart-y-ticks-left',
  yTicksRight: 'growth-dynamics-chart-y-ticks-right',
  chartLeft: 'growth-dynamics-chart-chart-left',
  chartRight: 'growth-dynamics-chart-chart-right',
  // rows:
  topLabelTop: 'growth-dynamics-chart-top-label-top',
  topLabelBottom: 'growth-dynamics-chart-top-label-bottom',
  xLegendTop: 'growth-dynamics-chart-x-legend-top',
  xLegendBottom: 'growth-dynamics-chart-x-legend-bottom',
  xAxisLabelTop: 'growth-dynamics-chart-x-label-top',
  xAxisLabelBottom: 'growth-dynamics-chart-x-label-bottom',
  xTicksTop: 'growth-dynamics-chart-x-ticks-top',
  xTicksBottom: 'growth-dynamics-chart-x-ticks-bottom',
  chartTop: 'growth-dynamics-chart-chart-top',
  chartBottom: 'growth-dynamics-chart-chart-bottom',
};

export const Root = styled(GraphAreaContainer)`
  display: grid;
  grid-template-columns:
    [${gridLines.yLegendLeft}] ${marginalLegendSize}px
    [${gridLines.yLegendRight} ${gridLines.yAxisLabelLeft}] ${axisLabelsSize}px
    [${gridLines.yAxisLabelRight} ${gridLines.yTicksLeft}] ${yAxisTicksWidth}px
    [${gridLines.yTicksRight} ${gridLines.chartLeft}] 1fr
    [${gridLines.chartRight}];
  grid-template-rows:
    [${gridLines.topLabelTop}] ${topLabelSize}px
    [${gridLines.topLabelBottom} ${gridLines.chartTop}] 1fr
    [${gridLines.chartBottom} ${gridLines.xTicksTop}] ${xAxisTicksHeight}px
    [${gridLines.xTicksBottom} ${gridLines.xAxisLabelTop}] ${marginalLegendSize}px
    [${gridLines.xAxisLabelBottom} ${gridLines.xLegendTop}] ${axisLabelsSize / 2}px
    [${gridLines.xLegendBottom}];
`;

export const ChartContainer = styled.div`
  grid-row: ${gridLines.chartTop} / ${gridLines.chartBottom};
  grid-column: ${gridLines.chartLeft} / ${gridLines.chartRight};
`;
export const YLegendContainer = styled.div`
  grid-row: ${gridLines.chartTop} / ${gridLines.chartBottom};
  grid-column: ${gridLines.yLegendLeft} / ${gridLines.yLegendRight};
`;
export const YAxisLabelContainer = styled.div`
  grid-row: ${gridLines.chartTop} / ${gridLines.chartBottom};
  grid-column: ${gridLines.yAxisLabelLeft} / ${gridLines.yAxisLabelRight};
`;
export const XxisLabelContainer = styled.div`
  grid-row: ${gridLines.xAxisLabelTop} / ${gridLines.xAxisLabelBottom};
  grid-column: ${gridLines.chartLeft} / ${gridLines.chartRight};
`;
export const XLegendContainer = styled.div`
  grid-row: ${gridLines.xLegendTop} / ${gridLines.xLegendBottom};
  grid-column: ${gridLines.chartLeft} / ${gridLines.chartRight};
`;
export const TopLabelContainer = styled.div`
  grid-row: ${gridLines.topLabelTop} / ${gridLines.topLabelBottom};
  grid-column: ${gridLines.chartLeft} / ${gridLines.chartRight};
`;
export const YTicksContainer = styled.div`
  grid-row: ${gridLines.chartTop} / ${gridLines.chartBottom};
  grid-column: ${gridLines.yTicksLeft} / ${gridLines.yTicksRight};
`;
